
export default {
  token: null
}



// WEBPACK FOOTER //
// ./src/store/modules/memed/state.js